
































































































































































// @ts-ignore
import v8n from 'v8n';
import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';
import { Lot, LotRegion, ApiError } from '@/api';
import { snackModule, authModule } from '@/store';
import { Route } from 'vue-router';
import AbstractTable from '@/components/admin/AbstractTable.vue';
import RegionEdit from '@/components/admin/RegionEdit.vue';
import ConfirmDialog from '@/components/admin/ConfirmDialog.vue';

@Component({
  components: {
    AbstractTable,
    RegionEdit,
    ConfirmDialog,
  },
})
export default class extends Vue {
  @Prop({ required: false }) readonly routeTitle: string;

  loading: boolean = false;
  valid: boolean = false;
  complete: boolean = false;
  error: string = '';

  lot: Lot | null = null;

  lotTypes: Array<{
    text: string | number | object;
    value: string | number | object;
    disabled?: boolean;
    divider?: boolean;
    header?: string;
  }> = [
    { text: 'Indoor', value: 'indoor' },
    { text: 'Outdoor', value: 'outdoor' },
  ];

  selectedRegions: LotRegion[] = [];
  regionConfirmDialog: boolean = false;
  regionAddEdit: boolean = false;
  regionToEdit: LotRegion | null = null;

  nextFn: (() => void) | null = null;
  leaveConfirmDialog: boolean = false;
  confirmLeaveContent: string =
    'Are you sure you would like to leave? Any unsaved changes will be lost.';

  requiredString = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'This field is required',
  ];
  requiredNumber = [
    (v: string) =>
      v8n()
        .number()
        .greaterThan(0)
        .test(Number(v)) || 'Must be a number greater than 0',
  ];
  validRate = [
    (v: string) =>
      v8n()
        .optional(
          v8n()
            .number()
            .between(0, 1),
          true,
        )
        .test(Number(v)) || 'Must be a number between 0 and 1',
  ];

  get windowSize() {
    return window.outerWidth;
  }

  get lotId() {
    return this.$route.params.lotId;
  }

  get regionHeaders() {
    return LotRegion.listHeaders();
  }

  get regionScope() {
    return () => LotRegion.where({ lot: this.lotId });
  }

  get selectedRegion() {
    return this.selectedRegions[0] || null;
  }

  regionClicked(item: LotRegion) {
    if (!item) {
      return;
    }

    this.regionToEdit = item;
    this.regionAddEdit = true;
  }

  addRegion(edit: boolean = false) {
    if (edit) {
      this.regionToEdit = this.selectedRegion;
    } else {
      this.regionToEdit = null;
    }

    this.regionAddEdit = true;
  }

  confirmDeleteRegion() {
    this.regionConfirmDialog = true;
  }

  regionSaved() {
    this.regionAddEdit = false;
    snackModule.showSnackbar('Region Saved');
    this.update();
  }

  regionClosed() {
    this.regionAddEdit = false;
  }

  update() {
    (this.$refs.regionTable as AbstractTable).update();
  }

  back() {
    this.$router.back();
  }

  beforeRouteLeave(to: Route, from: Route, next: (args?: any) => void) {
    if (this.lot && this.lot.isDirty()) {
      this.nextFn = next;
      this.leaveConfirmDialog = true;
      next(false);
    } else {
      next();
    }
  }

  leave() {
    if (this.nextFn) {
      this.nextFn();
    }
  }

  async deleteSelectedRegion() {
    if (!this.selectedRegion) {
      return;
    }

    try {
      await this.selectedRegion.destroy();
    } catch (err) {
      // Error
    } finally {
      this.regionConfirmDialog = false;
      this.selectedRegions = [];
      this.update();
    }
  }

  async save() {
    if (!this.lot) {
      return;
    }

    try {
      await this.lot.save();
      if (this.$route.name === 'admin-lots-add' && this.lot && this.lot.id) {
        this.$router.push({
          name: 'admin-lots-edit',
          params: { lotId: this.lot.id },
        });
        snackModule.showSnackbar('Lot Created');
      } else {
        snackModule.showSnackbar('Lot Updated');
      }
    } catch (err) {
      err.response.errors.forEach((e: ApiError) =>
        snackModule.showSnackbar(e.detail),
      );
    }
  }

  async mounted() {
    if (this.$route.name === 'admin-lots-edit' && this.lotId) {
      try {
        this.lot = (await Lot.find(this.lotId)).data;
      } catch (err) {
        // most likely this means not found
        snackModule.showSnackbar('Lot not found');
      }
    } else {
      this.lot = new Lot();
    }
  }
}
